import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AuthService } from 'src/app/core-services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ShippingLineService } from '../../landing/services/shippinglines.service';
import { UserService } from 'src/app/core-services/user.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-shippinglines-list',
    templateUrl: './shippinglines.component.html',
    styleUrls: ['./shippinglines.component.scss']
  })

export class ShippingLinesComponent implements OnInit {

    requestVM: AdminViewModel;
    totalcount: number = 0;
    shippingData: any;
    ShippingLineId: number = 0;
    rageYears: string;
    minDate: Date;
    masterRepresentatives: any[] = [];
    respresentatives: any;
    isReceiveFrieghtRequestOnly: boolean = false;;
    isPremiumListing: boolean = false;
    submitted: boolean = false;
    @ViewChild('shippingLineModal') shippingLineModal: any;
    modalRef: NgbModalRef | null = null;

    constructor(private fb: FormBuilder,private toastr: ToastrService, private adminService: AdminService, private authenticationService: AuthService,
       private spinner: NgxSpinnerService, private shippingLineService: ShippingLineService,
       private userService : UserService,
       private modalService: NgbModal) { }

    get f() { return this.ShippingForm.controls; }

    ShippingForm = this.fb.group({
      companyName: ['', [Validators.required]],
      companyCode: ['', [Validators.required]],
      // receiveFrieghtRequestOnly: [''],
      // premiumListing: [''],
      receiveFrieghtRequestExpiryDate: [''],
      premiumListingExpiryDate: [''],
      shippingRepresentative:[''],
      txtAreashippingRepresentative:['']
    });

    ngOnInit() {
      this.minDate = new Date();
      this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
      this.requestVM = new AdminViewModel();
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.getShippingLinesList();
      this.getRepresentativeList();
      
    }

    @ViewChild('closePortModal') closePortModal: ElementRef;

    openShippingLineModal(id: number) {
    this.ShippingLineId = id;

    if (id > 0) {
      this.getShippingdetails(id); // fetch values for editing
    } else {
      this.ShippingForm.reset();
    }

    this.modalRef = this.modalService.open(this.shippingLineModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

    getShippingLinesList() {
      if (this.requestVM != null && this.requestVM.pageNo > 0 && this.requestVM.pageSize > 0) {
        this.spinner.show();
        this.shippingLineService.GetShippingLinesList(this.requestVM).subscribe((response: any) => {
          if (response != null && response.data != null) {
            this.shippingData = response.data;
            this.totalcount = response.totalRecords;
            this.spinner.hide();
          }
          else if(response && response.errors &&  response.errors.length && response.errors[0]=="unauthenticated"){
                console.log("User is not login")
          }
          this.spinner.hide();
        })
      }
    }

    getRepresentativeList(){
      this.userService.GetRepresentativeList().subscribe((response: any)=>{
        if (response != null && response.data != null ) {
          this.masterRepresentatives = response.data;
        }
      })
    }

    paginate(event) {
      this.requestVM.pageNo = event.page + 1;
      this.requestVM.pageSize = event.rows;
      this.getShippingLinesList();
    }

    getShippingdetails(id) {

      this.ShippingLineId = id;
      this.ShippingForm.reset();

      this.shippingLineService.GetShippingLineDetails(this.ShippingLineId).subscribe((response: any) => {
       
        if (response != null && response.data != null ) {
            this.ShippingForm.controls.companyName.setValue(response.data.companyName);
            this.ShippingForm.controls.companyCode.setValue(response.data.companyCode);

            // this.ShippingForm.controls.receiveFrieghtRequestOnly.setValue(Boolean(response.content.isReceiveFrieghtRequestOnly));
            // this.ShippingForm.controls.premiumListing.setValue(Boolean(response.content.isPremiumListing));

            this.isReceiveFrieghtRequestOnly = Boolean(response.data.isReceiveFrieghtRequestOnly);
            this.isPremiumListing = Boolean(response.data.isPremiumListing);

            if (response.data.receiveFrieghtRequestExpiry != null 
              && response.data.receiveFrieghtRequestExpiry != undefined 
              && response.data.receiveFrieghtRequestExpiry != '') {
              var date = new Date(response.data.receiveFrieghtRequestExpiry);
              this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.setValue(date as any);
            }
            else{
              this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.setValue('');
            }

            if (response.data.premiumListingExpiry != null 
              && response.data.premiumListingExpiry != undefined 
              && response.data.premiumListingExpiry != '') {
              var date = new Date(response.data.premiumListingExpiry);
              this.ShippingForm.controls.premiumListingExpiryDate.setValue(date as any);
            }
            else{
              this.ShippingForm.controls.premiumListingExpiryDate.setValue('');
            }

            if(response.data.shippingRepresentatives.length >0){
              let selectedrepresentatives: any = this.masterRepresentatives.filter(x=>response.data.shippingRepresentatives.includes(x.id));
              this.ShippingForm.controls.shippingRepresentative.setValue(selectedrepresentatives);
              this.respresentatives = selectedrepresentatives.map(x=>x.userName).toString();
            }
        }
        else {
          this.toastr.error('Something went wrong!', 'Oops!!');
        }
      });  
    }

    onRepresentativeChange(event){
     this.respresentatives = event.value.map(x=>x.userName).toString();
    }
    
    save(){

      if (this.ShippingForm.invalid) {
        this.toastr.warning('Form Validation failed.', 'Oops !');
        return;
      }
      else{
        let data :any = {};
        //data.shippingId = this.ShippingLineId;
        data.companyName = this.ShippingForm.controls.companyName.value;
        data.companyCode = this.ShippingForm.controls.companyCode.value;
        // data.isReceiveFrieghtRequestOnly = this.ShippingForm.controls.receiveFrieghtRequestOnly.value;
        // data.isPremiumListing = this.ShippingForm.controls.premiumListing.value;
        data.isReceiveFrieghtRequestOnly = this.isReceiveFrieghtRequestOnly;
        data.isPremiumListing = this.isPremiumListing;

        if (this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value 
          && this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value != undefined 
          && this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value != ''){
            data.receiveFrieghtRequestExpiry = this.dateConvert(this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value);
        }

        if (this.ShippingForm.controls.premiumListingExpiryDate.value 
          && this.ShippingForm.controls.premiumListingExpiryDate.value != undefined 
          && this.ShippingForm.controls.premiumListingExpiryDate.value != ''){
            data.premiumListingExpiry = this.dateConvert(this.ShippingForm.controls.premiumListingExpiryDate.value);
          }

        if(this.ShippingForm.controls.shippingRepresentative.value!=null && this.ShippingForm.controls.shippingRepresentative.value.length>0){
          data.shippingRepresentatives = (this.ShippingForm.controls.shippingRepresentative.value as any)?.map(x=>x.id);
        }

        this.shippingLineService.AddShippingLine(data).subscribe((response: any) => {
          if (response != null && response.succeeded) {
            this.ShippingForm.reset();
            // this.closePortModal.nativeElement.click();
            this.modalRef.close();
            this.toastr.success('Record Has been Updated..!', '');
            this.getShippingLinesList();
          }
          else {
            this.shippingData.reset();
            this.toastr.error('Record not Updated..!', 'Oops');
          }
        });  

      }
    }
    update(){
      this.submitted = true;
      if (this.ShippingForm.invalid) {
        this.toastr.warning('Form Validation failed.', 'Oops !');
        return;
      }
      else{
        let data :any = {};
        data.shippingId = this.ShippingLineId;
        data.companyName = this.ShippingForm.controls.companyName.value;
        data.companyCode = this.ShippingForm.controls.companyCode.value;
        // data.isReceiveFrieghtRequestOnly = this.ShippingForm.controls.receiveFrieghtRequestOnly.value;
        // data.isPremiumListing = this.ShippingForm.controls.premiumListing.value;
        data.isReceiveFrieghtRequestOnly = this.isReceiveFrieghtRequestOnly;
        data.isPremiumListing = this.isPremiumListing;

        if (this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value 
          && this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value != undefined 
          && this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value != ''){
            data.receiveFrieghtRequestExpiry = this.dateConvert(this.ShippingForm.controls.receiveFrieghtRequestExpiryDate.value);
        }

        if (this.ShippingForm.controls.premiumListingExpiryDate.value 
          && this.ShippingForm.controls.premiumListingExpiryDate.value != undefined 
          && this.ShippingForm.controls.premiumListingExpiryDate.value != ''){
            data.premiumListingExpiry = this.dateConvert(this.ShippingForm.controls.premiumListingExpiryDate.value);
          }

        if(this.ShippingForm.controls.shippingRepresentative.value!=null && this.ShippingForm.controls.shippingRepresentative.value.length>0){
          data.shippingRepresentatives = (this.ShippingForm.controls.shippingRepresentative.value as any)?.map(x=>x.id);
        }

        this.shippingLineService.UpdateShippingLine(data).subscribe((response: any) => {
          if (response != null && response.succeeded) {
            this.ShippingForm.reset();
            // this.closePortModal.nativeElement.click();
            this.modalRef.close();
            this.toastr.success('Record Has been Updated..!', '');
            this.getShippingLinesList();
          }
          else {
            this.shippingData.reset();
            this.toastr.error('Record not Updated..!', 'Oops');
          }
        });  

      }
    }

    resetvalues(){
      this.ShippingForm.reset();
    }

    dateConvert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
  
    }
    
    filterSearch(searchText) {
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.searchText = searchText;
      this.getShippingLinesList();
    }

  }